<script setup lang="ts">
import type { SaleItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: SaleItemEntity;
}
const { sale } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
</script>

<template>
    <UAlert
        v-if="sale.includesDepotService"
        :title="tt('sdp.depot.title')"
        :description="tt('sdp.depot.description')"
        color="neutral"
        variant="subtle"
    >
        <template #actions>
            <SdpDepotVisitBookingModalButton :sale="sale" size="sm" />
        </template>
    </UAlert>
</template>
